<template>
  <div id="list-items" class="list-items _collapsed">
    <div v-if="title" class="list-items__label">{{ title }}</div>

    <ul v-if="items.length" class="list-items__list" :class="cssClass">
      <li v-for="(item, index) in visibleItems" :key="index" class="list-item">
        <slot :item="item">
          <span v-if="formatHtml" v-html="item"></span>
          <template v-else>{{ item }}</template>
        </slot>
      </li>

      <li v-if="hiddenItemsCount" class="dc__show-more">
        <a href="#" class="dc-show-more__link" @click="expanded = true">
          <svg width="12" height="12">
            <use xlink:href="#arrow-sides"></use>
          </svg>
          Показать все ({{ items.length }})
        </a>
      </li>

      <li v-if="expandable && expanded" class="dc__show-more _opened">
        <a href="#" class="dc-show-more__link" @click="expanded = false">
          <svg width="12" height="12">
            <use xlink:href="#arrow-sides"></use>
          </svg>
          Скрыть
        </a>
      </li>
    </ul>

    <div v-else-if="emptyText" class="message _attention">{{ emptyText }}</div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },

    items: {
      type: Array,
      required: true
    },

    /**
     * Опция раскрывающегося списка. Возможные значения:
     * false - список не раскрывается (всегда видны все элементы списка);
     * true - список раскрывается (по умолчанию все элементы скрыты);
     * Number - аналогично true, но первые Number элементов всегда видны.
     */
    expandable: {
      type: [Boolean, Number],
      default: false
    },

    formatHtml: {
      type: Boolean,
      default: false
    },

    emptyText: {
      type: String,
      default: ''
    },

    cssClass: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      expanded: this.expandable === false
    };
  },

  computed: {
    visibleItems() {
      return this.expanded
        ? this.items
        : this.expandable === true
        ? []
        : this.items.slice(0, this.expandable);
    },

    hiddenItemsCount() {
      return this.items.length - this.visibleItems.length;
    }
  },

  methods: {
    expand() {
      this.expanded = true;
    }
  }
};
</script>

<style lang="css" src="./list-items.css" />
